import React from "react";
import { useParams } from "react-router-dom";
import { useGetProductByIdQuery } from "../../../services/productListApiSice";
import { SpareDetail } from "../../../component/spares/spareDetail/SpareDetail";
import { formatNumber } from "../../../utils/formatNumber";
import classes from "./productDetailPage.module.css";

export const ProductDetailPage = () => {
  const { category, productId } = useParams();
  const { data, isFetching, isError, error } = useGetProductByIdQuery({
    category,
    request_id: productId,
  });
  console.log(data ? data : "No data available");
 
  return (
    <div className={classes.box}>
      <SpareDetail
        spareData={data}
        // images={data?.images}
        // prices={prices}
        // color={data?.color}
        // partName={data?.part_name}
        //   onColorSelect={handleColorSelect}
        //   descriptions={data?.description}
        //   onAddToCart={handleAddToCart}
        // cart_status={data?.data?.data.cart_status}
        // wishlist_status={data?.data?.data.wishlist_status}
        // onWishList={handleAddToWishList}
      />
    </div>
  );
};
